import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useRef, useCallback, useEffect } from 'react';
import { useArrayIterator } from '@dtvgo/react-utils';

function useSourceSelector(sources, _ref) {
  var getProgress = _ref.getProgress;
  var _useArrayIterator = useArrayIterator(sources),
    _useArrayIterator2 = _slicedToArray(_useArrayIterator, 2),
    source = _useArrayIterator2[0],
    next = _useArrayIterator2[1];
  var startOffset = useRef();
  var nextSource = useCallback(function () {
    if (!next()) return false;
    startOffset.current = getProgress();
    return true;
  }, [getProgress, next, startOffset]);
  useEffect(function () {
    startOffset.current = null;
  }, [sources]);
  return {
    source: source,
    nextSource: nextSource,
    startOffset: startOffset.current
  };
}

export { useSourceSelector };
//# sourceMappingURL=useSourceSelector.js.map
